'use strict';

import 'slick';
import lazyloadSlider from './lazyloadSlider';

export default function slicks($slider, options = {}) {

    if (!$slider.length) {
        return;
    }

    let defaults = {
        arrows: true,
        slidesToShow: 3,
        nextArrow: '<span class="slick-next slick-arrow"><span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span></span>',
        prevArrow: '<span class="slick-prev slick-arrow"><span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span></span>'
    };


    $slider.on('afterChange', () => {
        $slider.trigger('scroll');
    });

    $slider.each((idx, el) => {
        let $thisSlider = $(el),
            settings = $.extend({}, defaults, options);

        $thisSlider.on('init', (event, slick) => {
            let slidesCount = slick.slideCount;

            for (let i = 0, len = settings.slidesToShow; i < len; i++) {
                lazyloadSlider(slick.$slider, - i - 1);
                lazyloadSlider(slick.$slider, slidesCount + i);
            }
        });

        $thisSlider.slick(settings);
    });

    return $slider;
}
